import React from "react";
import PropTypes from "prop-types";
//Material imports
import Typography from "@mui/material/Typography";
import withStyles from "@mui/styles/withStyles";
//Limitless imports

const RenderFieldState = ({
  classes,
  state
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: `${classes.box} ${classes[state.value]}`
  }, /*#__PURE__*/React.createElement(Typography, {
    color: "inherit",
    align: "center",
    className: classes.title,
    variant: "body1"
  }, state.label));
};
const styles = theme => {
  const stickyStyles = {
    color: "#fff",
    backgroundColor: theme.palette.primary.main
  };
  const inboxStyles = {
    color: "#fff",
    backgroundColor: theme.palette.primary.dark
  };
  const successStyles = {
    color: "#fff",
    backgroundColor: theme.palette.success.main
  };
  const errorStyles = {
    color: "#fff",
    backgroundColor: theme.palette.error.main
  };
  const timeoutStyles = {
    color: "#fff",
    backgroundColor: "#800080" //purple
  };
  return {
    box: {
      borderRadius: 4,
      padding: 4
    },
    title: {
      fontWeight: 700
    },
    pass: {
      color: "#fff",
      backgroundColor: theme.palette.primary.main
    },
    fail: errorStyles,
    incomplete: {
      color: "#fff",
      backgroundColor: "#757575" //grey
    },
    all: stickyStyles,
    review: inboxStyles,
    reviewFee: inboxStyles,
    reviewEscalation: inboxStyles,
    reviewQuality: inboxStyles,
    respond: inboxStyles,
    respondSticky: stickyStyles,
    respondNew: inboxStyles,
    respondExisting: inboxStyles,
    AVAILABLE: stickyStyles,
    RUNNING: stickyStyles,
    ARCHIVE: stickyStyles,
    ABORTED: errorStyles,
    SUCCEEDED: successStyles,
    COMPLETED: successStyles,
    FAILED: errorStyles,
    TIMED_OUT: timeoutStyles,
    Started: inboxStyles,
    Completed: successStyles
  };
};
export default withStyles(styles)(RenderFieldState);
RenderFieldState.propTypes = {
  classes: PropTypes.object.isRequired,
  state: PropTypes.object.isRequired
};